/**
 * This file is the entry point for the React app, it sets up the root
 * element and renders the App component to the DOM.
 *
 * It is included in `src/index.html`.
 */

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import {
	SidebarInset,
	SidebarProvider,
	SidebarTrigger,
} from "@/components/ui/sidebar";
import { AppSidebar } from "@/components/app-sidebar";

const elem = document.getElementById("root");
if (!elem) throw new Error("#root not found");
const app = (
	<StrictMode>
		<SidebarProvider>
			<AppSidebar />
			<SidebarInset>
				<div className="p-2">
					<SidebarTrigger className="float-left" />
				</div>
				<div className="flex-1 min-h-0 w-full">
					<App />
				</div>
			</SidebarInset>
		</SidebarProvider>
	</StrictMode>
);

if (import.meta.hot) {
	// With hot module reloading, `import.meta.hot.data` is persisted.
	const hotData = import.meta.hot.data as {
		root?: ReturnType<typeof createRoot>;
	};
	const root = hotData.root ?? createRoot(elem);
	hotData.root = root;
	root.render(app);
} else {
	// The hot module reloading API is not available in production.
	createRoot(elem).render(app);
}
